"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Container_1 = __importDefault(require("../../Container/Container"));
var framer_motion_1 = require("framer-motion");
var Switch = function (_a) {
    var active = _a.active, _b = _a.className, className = _b === void 0 ? '' : _b, onChange = _a.onChange, name = _a.name, automatedTestId = _a.automatedTestId;
    function getAnimationProperties() {
        if (active) {
            return {
                animate: {
                    left: 'calc(100% - 20px)'
                },
                transition: {
                    duration: 0.2,
                    ease: 'easeIn'
                }
            };
        }
        return {
            animate: {
                left: 0
            },
            transition: {
                duration: 0.2,
                ease: 'easeInOut'
            }
        };
    }
    function handleOnChange(event) {
        event.preventDefault();
        if (onChange)
            onChange(name);
    }
    var animationProperties = getAnimationProperties();
    return (react_1.default.createElement(Container_1.default, { className: "sds-switch-input " + (active ? 'active' : '') + " " + className },
        react_1.default.createElement(framer_motion_1.motion.div, { className: 'sds-switch-dot', onClick: handleOnChange, animate: animationProperties.animate, transition: animationProperties.transition, id: automatedTestId, "data-testid": automatedTestId })));
};
exports.default = Switch;
